export default __webpack_public_path__ + "static/media/11.98c589df.png";